import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from "axios"
import {
  FormGroup,
  Alert
} from "reactstrap";
import Reaptcha from "reaptcha";


export default function ContactForm() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [visible, setVisible] = useState(false);
  const onDismiss = () => setVisible(false);
  const [recaptcha, setRecaptcha] = useState("");
  const [showValid, setShowValid] = useState(false);
  const { register, handleSubmit, errors, reset } = useForm();
  const onSubmit = data => {
      if(recaptcha.length < 1){
          setShowValid(true);
      }else{
          setShowValid(false);
          data.token = recaptcha;
          axios({
              method: "POST",
              url: process.env.API_URL,
              data: data,
              headers :{
                  'Content-Type': 'application/json'
              }
          }).then((response)=>{
              setIsSuccess(true);
              setRecaptcha("");
              setVisible(false);
              reset();
          })
          .catch((error)=>{
              console.log(error);
              setVisible(true);
          })
      }
  };
 
  const onVerify = recaptchaResponse => {
    setRecaptcha(recaptchaResponse);
  };

  return (
    <div className='contact-form'>
        {isSuccess ?
            <div className="success-form-submit">
                <h2>Your message has been send successfully!</h2>
                <h3>Thank you for getting in touch!</h3>
                <p>We appreciate you contacting us. One of our colleagueswill get back in touch with you soon!</p>
                <p>Have a great day</p>
                <button onClick={()=>setIsSuccess(false)} className="button-basic primary-invert">Send new message</button>
            </div>
            :
            <form onSubmit={handleSubmit(onSubmit)}>
                <legend>
                    <h2>Contact form</h2>
                </legend>
                <Alert color="danger" isOpen={visible} toggle={onDismiss} fade={false}>
                   Message failed to send, try again
                </Alert>

                <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input type="text" placeholder="Name" className="form-control" name="name"
                           ref={register({required: true, maxLength: 80})}/>
                    {errors.name && <div className="requirements">This field is required</div>}
                </div>
                <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Email address</label>
                    <input type="text" className="form-control" placeholder="Email" name="email" ref={register({
                        required: true,
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                            message: "Invalid email address."
                        }
                    })}/>
                    {errors.email && <div className="requirements">{errors.email.message} This field is required</div>}
                </div>
                <div className="form-group">
                    <label htmlFor="message">Message</label>
                    <textarea name="message" className="form-control" ref={register({required: true})} rows="5"/>
                    {errors.message && <div className="requirements">This field is required</div>}
                </div>

                <div className="form-group">
                    <Reaptcha sitekey={process.env.RECAPTCHA_API_KEY} onVerify={onVerify}/>
                    {showValid && <div className="requirements">This field is required</div>}
                </div>

                <FormGroup>
                    <div className="button-div">
                        <input type="submit" value="Submit" className="button-basic primary-invert"/>
                    </div>
                </FormGroup>
            </form>
        }
    </div>
  );
}